import * as Sentry from '@sentry/react-router';
import type { BrowserOptions } from '@sentry/react-router';

let enabled = false;

const performanceTracking = {
    init(options: BrowserOptions): void {
        if (!options.dsn) return;
        Sentry.init(options);
        enabled = true;
    },

    trackPageLoad(page: string): void {
        if (!enabled) return;

        Sentry.captureEvent({
            message: 'page_load',
            level: 'info',
            tags: { page, event_type: 'page_performance' },
        });
    },
};

export default performanceTracking;
